export default "__VITE_ASSET__Ca8vZzTG__"